// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { MissionStore, setPayloadSliderFalse, setPayloadSliderTrue } from '../../../../../store/MissionSlice';
import { Button, Dropdown, OverlayTrigger, Popover } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { calculatePayloadUsage, calculate_Total_AOP_Usage, navigateTo } from '../../../../../utils/commonFunctions';
import { Steps } from '../../Stepper.constants';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../../../../Layouts/PageHeader/PageHeader';
import PayloadSlider from './PayloadSlider';
import CloseButton from '../../../../CommonComponents/CloseButton';
import MissionService from '../../../../../service/MissionService';
import { usageStore } from '../../../../../store/UsageSlice';
import Loader from '../../../../../Layouts/Loader/Loader';
import ConfirmationDialog from '../../../../CommonComponents/confirmation_dialog/ConfirmationDialog';
import { showToastMessage } from '../../../../../utils/commonFunctions';

const PreviewPayloads = () => {
    const params = useParams()
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { mission_name, mission_id, sat_name, sat_id } = params


    const isPayloadSlider = useSelector(
        (state: { mission: MissionStore }) => state.mission.isPayloadSlider
    );

    const [payloadSliderData, setPayloadSliderData] = useState<any>({});

    const payloadSizeUsage = useSelector((state: { usage: usageStore }) => state.usage.payloadSizeUsage);
    const payloadWeightUsage = useSelector((state: { usage: usageStore }) => state.usage.payloadWeightUsage);
    const payloadPowerUsage = useSelector((state: { usage: usageStore }) => state.usage.payloadPowerUsage);
    const totalPayloadAOPUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.totalPayloadAOPUsage
    );

    const [selectedInterface, setSelectedInterface] = useState<any[]>([]);
    const [satPayloads, setSatPayloads] = useState<any[]>([]);
    const [satEdges, setSatEdges] = useState<any[]>([]);
    const [satellieteDeta, setSatellieteData] = useState<any>({});
    const [loading, setLoading] = useState(true);
    const [isPayloadDelete, setIsPayloadDelete] = useState(false);

    const [deletedPayloadData, setDeletedPayloadData] = useState<any>({});
    const [openDeleteModel, setOpenDeleteModal] = useState<any>(false);
    const [satName, setSatName] = useState("")

    const get_satellite = async () => {
        try {
            const satResponse = await MissionService.get_satellite_by_sat_id(sat_id, mission_id)
            const edgeResponse = await MissionService.get_edge_by_sat_id(sat_id, mission_id)
            const payloadResponse = await MissionService.get_payload_by_sat_id(sat_id, mission_id)

            const satelliteDetails = satResponse?.data
            const edgeDetails = edgeResponse?.data || []
            const payloadDetails = payloadResponse?.data || []
            setSatName(satelliteDetails?.name)
            setSatellieteData(satelliteDetails)
            setSatEdges(edgeDetails)
            setSatPayloads(payloadDetails)
            calculatePayloadUsage(payloadDetails, dispatch) //calculating swap info for edge
            calculate_Total_AOP_Usage(payloadDetails, edgeDetails, dispatch) //calculating power for swap info
        } catch (error) {
            showToastMessage('error', "Something went wrong while getting payload data");
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (sat_id) {
            get_satellite()
        }
    }, [sat_id]);

    // Show success toast on this page after load (when navigated from add/update payload)
    useEffect(() => {
        if (!loading && location.state?.payloadSuccessMessage) {
            showToastMessage('success', location.state.payloadSuccessMessage);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [loading, location.state?.payloadSuccessMessage]);

    const deletePreviewPayloads = async (data) => {
        setLoading(true)
        try {
            let filterPayload = satPayloads?.filter(item => item?.['userData']?.['id'] != data?.['userData']?.['id'])
            const { size, power, weight } = calculatePayloadUsage(filterPayload, dispatch) //calculating swap info for edge
            const { total_payload_aop } = calculate_Total_AOP_Usage(filterPayload, satEdges, dispatch) //calculating power for swap info
            await MissionService.delete_payload(mission_id, sat_id, data?.uniqueId)
            const satResponse = await MissionService.get_satellite_by_sat_id(sat_id, mission_id)

            const satelliteDetails = satResponse?.data
            const swapInfo = {
                totalPayloadSize: size,
                totalPayloadMass: weight,
                totalPayloadPower: power,
                totalPayloadAop: total_payload_aop,
                totalEdgeMass: satelliteDetails?.swapInfo?.totalEdgeMass || 0,
                totalEdgePower: satelliteDetails?.swapInfo?.totalEdgePower || 0,
                totalEdgeSize: satelliteDetails?.swapInfo?.totalEdgeSize || 0,
                totalEdgeAop: satelliteDetails?.swapInfo?.totalEdgeAop || 0,
            }
            const updatedSatellite = {
                ...satelliteDetails,
                draftMode: true,
                templateId: '',
                swapInfo: swapInfo
            }
            await MissionService.edit_satellite(mission_id, sat_id, updatedSatellite)
            setSatPayloads(filterPayload)
            showToastMessage('success', 'Payload deleted successfully');
            if (filterPayload?.length === 0) {
                navigateTo(`${mission_name}/${mission_id}/${sat_id}/add_new_payload`, navigate)
            }
        } catch (error) {
            console.log(error);
            calculatePayloadUsage(satPayloads, dispatch)
            calculate_Total_AOP_Usage(satPayloads, satEdges, dispatch)
            showToastMessage('error', "Something went wrong while deleting payload");
        } finally {
            setLoading(false)
        }

    }

    const navigate_to_step = (step) => {
        if (satPayloads?.length > 0) {
            if (step === 'Edge') {
                if (satEdges && satEdges?.length > 0) {
                    navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_edge`, navigate)
                } else {
                    navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/add_new_edge`, navigate)
                }
            }
        } else {
            showToastMessage('error', "Add atleast one payload to proceed")
        }
    }


    return <div className='h-100 w-100 d-flex flex-column overflow-hidden'>
        {loading && <Loader />}
        <PageHeader
            sat_name={satName}
            titles={"Payload Devices"}
            description={"Payloads currently configured in this satellite"}
            active="New Mission"
            items={["Apps"]}
            isButton={false}
            showSwap={true}
            showPercent={false}
            type=''
            value=''
        />

        <div className="d-flex flex-wrap flex-1 overflow-auto py-4 gap-4 ps-7 align-content-start">
            {satPayloads?.length > 0 && satPayloads?.map((v, id) => {
                let weight = v?.['atmosData']?.['weight_in_gms'];
                return (
                    <div className='common-card-box-preview m-0' key={id} style={{ width: '440px' }}>
                        <div className="common-card-header d-flex justify-content-between align-items-start">
                            <div className="w-100 d-flex gap-2 align-items-center">
                                <img
                                    src={v['atmosData']?.['src']}
                                    className="ms-2"
                                    width="30px"
                                    height="30px"
                                    alt={'icom'}
                                />
                                <div className='w-90'>
                                    <h4 className="mb-0 w-98 text-truncate" title={v?.["userData"]?.["payload_name"]}>
                                        {v?.["userData"]?.["payload_name"]}
                                    </h4>
                                    <div className="sat-sub-info">
                                        <span>
                                            {v?.['atmosData']?.['component_specific_attributes']?.['payloadType']}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-list more-button">
                                <Dropdown drop='end'>
                                    <Dropdown.Toggle variant="transparent text-white fs-20">
                                        <i className="fe fe-more-vertical"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item eventKey="1" onClick={() => {
                                            if (isPayloadSlider) {
                                                dispatch(setPayloadSliderFalse())
                                            }
                                            setSelectedInterface(
                                                v?.['userData']?.['selected_interfaces']
                                            );
                                            setPayloadSliderData(v);
                                            dispatch(setPayloadSliderTrue())
                                        }}>Summary</Dropdown.Item>
                                        <Dropdown.Item eventKey="2"
                                            onClick={() => {
                                                if (isPayloadSlider) {
                                                    dispatch(setPayloadSliderFalse());
                                                }
                                                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/edit_payload/${v?.['userData']?.['payload_name']}/${v?.['userData']?.['id']}`, navigate);
                                            }}>
                                            Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="3" onClick={() => {
                                            if (isPayloadSlider) {
                                                dispatch(setPayloadSliderFalse())
                                            }
                                            setDeletedPayloadData(v)
                                            setOpenDeleteModal(true)
                                        }
                                        }>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                        <div className="common-card-content">
                            <div className="d-flex flex-wrap">
                                <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['product-cookie']?.['Size'] + ' U'}</strong>
                                    <span>Size</span>
                                </div>
                                <div className="stats-alpha">
                                    <strong>{(weight > 999) ? ((weight / 1000) + ' kg') : (weight + ' g')}</strong>
                                    <span>Mass</span>
                                </div>
                                <div className="stats-alpha">
                                    <strong>{v?.["userData"]?.['downlinkDatasize']} MB</strong>
                                    <span>Data Per Pass</span>
                                </div>
                                <div className="stats-alpha">
                                    <strong>{v?.["userData"]?.['time_per_orbit']} min</strong>
                                    <span>Time Per Orbit</span>
                                </div>
                                <div className="stats-alpha">
                                    <strong>{v?.["userData"]?.['aop'] + ' W'}</strong>
                                    <div className="d-flex align-items-center">
                                        <span>OAP</span>
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={
                                                <Popover id="popover-basic">
                                                    <Popover.Body>
                                                        <span className='color-text text-center d-flex'>Orbit Average Power</span>
                                                    </Popover.Body>
                                                </Popover>
                                            }
                                        >
                                            <sup>
                                                <i className="fe fe-info ms-1 fs-12 text-info"></i>
                                            </sup>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="stats-alpha">
                                    <strong>{v?.["userData"]?.['AltMeasureAccuracy'] ? v?.["userData"]?.['AltMeasureAccuracy'] : 0}{'\u00B0'}</strong>
                                    <span>Attitude Accuracy</span>
                                </div>
                                <div className="stats-alpha">
                                    <strong>{v?.["userData"]?.['dutyCycle']} %</strong>
                                    <span>Pass Duty Cycle</span>
                                </div>
                                <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['max_power_consumption_in_watts'] + ' W'}</strong>
                                    <span>Peak Power</span>
                                </div>

                                {v?.['atmosData']?.['product-cookie']?.['Coding Scheme'] && <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['product-cookie']?.['Coding Scheme']}</strong>
                                    <span>Coding Scheme</span>
                                </div>}

                                {v?.['atmosData']?.["component_specific_attributes"]?.["typeSpecificParams"]?.['Data Rate'] && <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.["component_specific_attributes"]?.["typeSpecificParams"]?.['Data Rate']} Mbps</strong>
                                    <span>Data Rate</span>
                                </div>}

                                {v?.['atmosData']?.['product-cookie']?.['Gain'] && <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['product-cookie']?.['Gain']}</strong>
                                    <span>Gain</span>
                                </div>}

                                {v?.['atmosData']?.['product-cookie']?.['Modulation'] && <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['product-cookie']?.['Modulation']}</strong>
                                    <span>Modulation</span>
                                </div>}

                                {v?.['atmosData']?.['product-cookie']?.['Polarization'] && <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['product-cookie']?.['Polarization']}</strong>
                                    <span>Polarization</span>
                                </div>
                                }
                                {v?.['atmosData']?.['product-cookie']?.['Tx channels'] && <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['product-cookie']?.['Tx channels']}</strong>
                                    <span>TX Channel</span>
                                </div>
                                }

                                {v?.['atmosData']?.['average_power_consumption'] && <div className="stats-alpha">
                                    <strong>{v?.['atmosData']?.['average_power_consumption'] + ' W'}</strong>
                                    <span>Average Power</span>
                                </div>}


                                {v?.['atmosData']?.["component_specific_attributes"]?.["typeSpecificParams"]?.['Frequency Bands'] && v?.['atmosData']?.["component_specific_attributes"]?.["typeSpecificParams"]?.['Frequency Bands'].length > 0 &&
                                    <div className="d-flex flex-column mt-3">
                                        <div className="d-flex gap-1 w-100 flex-wrap">
                                            {v?.['atmosData']?.["component_specific_attributes"]?.["typeSpecificParams"]?.['Frequency Bands'].map((val, i) => {
                                                return (
                                                    <div key={i} className="d-flex gap-1">
                                                        <strong>{val}</strong>
                                                        <strong>{`${v?.['atmosData']?.["component_specific_attributes"]?.["typeSpecificParams"]?.['Frequency Bands'].length !== i + 1 ? '|' : ''}`}</strong>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <span>Frequency Bands</span>
                                    </div>}

                            </div>
                        </div>
                        <div className="common-card-footer">
                            <span className="footer-title">Interface</span>
                            <div className="d-flex w-100 flex-wrap">
                                {v?.['atmosData']?.['component_specific_attributes']?.['interfaces'].map((data, i) => {
                                    return (
                                        <div className={v?.['atmosData']?.['component_specific_attributes']?.['interfaces'].length > 0 && v?.['userData']?.['selected_interfaces'].includes(data) ? "badge-pill-active mb-2" : 'badge-pill-inactive mb-2'} key={i}>
                                            <span>{data}</span>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )
            })}
            <div className="common-card-box-empty d-flex justify-content-center"
                style={{ width: '440px' }}
                onClick={() => {
                    if (isPayloadSlider) {
                        dispatch(setPayloadSliderFalse());
                    }
                    navigateTo(`${mission_name}/${mission_id}/${sat_id}/add_new_payload`, navigate)
                }}
            >
                {satPayloads?.length > 0 && <div className="d-flex flex-column text-center gap-3">
                    <i className="fe fe-plus fs-50 fw-light"></i>
                    <span className='fs-16'>Add Payload</span>
                </div>}
                {satPayloads?.length === 0 && <div className="d-flex flex-column text-center gap-3">
                    <i className="fe fe-plus fs-50 fw-light"></i>
                    <div className='d-flex flex-column'>
                        <span className="fs-18">No payload selected yet</span>
                        <span className='fs-16'>Click here to configure a new Payload</span>
                    </div>
                </div>}
            </div>
        </div>
        <div className='h-100p'>
            <div className="navigator-btn gap-3">
                <CloseButton />
                <Button
                    variant="primary"
                    type="button"
                    className="d-flex align-items-center btn btn-primary pt-1 pb-1 pe-4 ps-5 fs-14"
                    onClick={() => {
                        if (satPayloads?.length > 0) {
                            if (isPayloadDelete) {
                                setIsPayloadDelete(false)
                            }
                            if (satEdges.length > 0) {
                                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_edge`, navigate)
                            } else {
                                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/add_new_edge`, navigate)
                            }
                        } else {
                            showToastMessage('error', "Add atleast one payload to proceed")
                        }
                    }}
                >
                    {isPayloadDelete ? 'Save & Continue' : 'Next'}
                    <i className="fe fe-chevron-right ms-1 fs-16"></i>
                </Button>
            </div>
            <div className="stepper-container">
                <div className="breadcrumb">
                    {Steps?.map((data, i) => {
                        return <a
                            onClick={() => { navigate_to_step(data.title) }}
                            className={data.title === 'Payloads' ? 'active' : ''}
                            key={i}>
                            <span className={"breadcrumb__inner"}>
                                <span className="breadcrumb__title">
                                    {data.svg}
                                </span>
                                <span className="breadcrumb__desc">{data.title}</span>
                            </span>
                        </a>
                    })}
                </div>
            </div>
        </div>


        {isPayloadSlider && (
            <PayloadSlider
                payloadSliderData={payloadSliderData}
            />
        )}

        <ConfirmationDialog
            type='delete'
            open={openDeleteModel ? true : false}
            title={`Delete Payload?`}
            description={`Deleting ${deletedPayloadData?.["userData"]?.["payload_name"]} will permanently remove it from the database, and it cannot be restored once deleted.`}
            onCancel={() => {
                setOpenDeleteModal(false)
                setDeletedPayloadData({})
            }}
            onConfirm={() => {
                deletePreviewPayloads(deletedPayloadData)
                setOpenDeleteModal(false)
                setDeletedPayloadData({})
            }}
            confirm_button_text={`Delete`}
        />
    </div>;

};
export default PreviewPayloads;
